// gkc_hash_code : 01EV64EDXCZTX8ZCEMHJHDQ126
export const globalText = {
  validation: {
    require: '{{type}}を入力してください',
    max_length: '最大字数が達成しました。',
    email: 'メールアドレスの形式が正しくありません',
    max_length_input:
      '{{type}}が、許可されている最大文字数を超えています。（最大の文字数は{{count}}文字です）',
  },
  modal: {
    delete: '登録情報を削除しますか？',
  },
  button: {
    delete: '削除する',
    cancel_delete: 'キャンセル',
    to_home: 'トップに戻る',
  },
  heading: {
    not_found: 'ご指定のデータは見つかりませんでした。',
  },
  get_app: {
    title: 'アプリをダウンロードして<br>マガジンをチェック！',
    legend: 'ダウンロードはこちら',
    ios_link: 'iPhoneをお使いの方',
    android_link: 'Androidスマホをお使いの方',
    open_reset_password: 'パスワード変更はこちら',
    open_magazine: 'アプリを開く',
    open_app: 'アプリで開く',
    open_app_not_found: 'アプリを開く',
    download: 'アプリのダウンロードはこちら',
    change_password: 'パスワード変更はこちら',
    not_found1: '指定のURLが見つかりません。',
    not_found2: 'アプリをダウンロードして',
    not_found3: 'その他のコンテンツをチェック',
    qr_code_not_found_first_line: '無効なQRコードです',
    qr_code_not_found_second_line: 'このコンテンツは現在提供していません',
  },
};
